import styled from 'styled-components';
import { colors } from '../../../../colors';
const SliderLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 3.75rem;
  height: 2rem;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;
const SliderSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.mineShaft};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &:before {
    position: absolute;
    content: '';
    height: 1.5rem;
    width: 1.5rem;
    left: 0.25rem;
    bottom: 0.25rem;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
`;
const SliderInput = styled.input`
  &:checked + span {
    background-color: ${colors.mandy};
  }
  &:focus + span {
    box-shadow: 0 0 1px ${colors.mandy};
  }
  &:checked + span:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
`;
export { SliderInput, SliderLabel, SliderSpan };